<template>
  <div class="q-ml-md">
    <q-form ref="form">
      <div class="row q-mb-md">
        <div class="labelTitle companyNameLabelWidth">Company Name</div>
        <div>
          <q-input
            filled
            dense
            bg-color="white"
            v-model="formData.companyName"
            style="border-radius: 5px; width: 302px"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-input>
        </div>
      </div>
      <div class="row q-mb-md">
        <div class="labelTitle websiteLabelWidth">
          Suggested Supplier Website
        </div>
        <div>
          <q-input
            v-model="formData.website"
            filled
            dense
            bg-color="white"
            style="border-radius: 5px; width: 302px"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-input>
        </div>
      </div>
      <div class="row">
        <div class="labelTitle commentLabelWidth">Comment</div>
        <div class="q-mr-md">
          <q-input
            v-model="formData.comment"
            filled
            dense
            bg-color="white"
            style="border-radius: 5px; width: 302px"
            :rules="[(v) => !!v || 'Field is Required']"
            type="textarea"
          >
          </q-input>
        </div>
        <sustainability-button
          v-if="!isLoading"
          class="bg-primary self-end"
          width="114px"
          height="26px"
          borderRadius="3px"
          @click="suggestSupplier"
        >
          <div class="row justify-center items-center full-height">
            <div class="buttonText text-white">Submit for Approval</div>
          </div>
        </sustainability-button>
        <q-circular-progress
          v-else
          indeterminate
          size="30px"
          color="primary"
          class="self-end"
        />
      </div>
    </q-form>
  </div>
</template>

<script>
import SustainabilityButton from "@/components/sustainabilityButton/sustainabilityButton.vue";
export default {
  components: {
    SustainabilityButton,
  },
  data: () => ({
    formData: {
      companyName: "",
      website: "",
      comment: "",
    },
    isLoading: false,
  }),
  methods: {
    async suggestSupplier() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        this.formData["solutions_id"] = this.$route.params.id;
        let result = await this.$store.dispatch(
          "mailing/suggestSupplier",
          this.formData
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.isLoading = false;
          this.closeForm();
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
          this.isLoading = false;
        }
      }
    },
    closeForm() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.labelTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}

.companyNameLabelWidth {
  width: 70px;
  margin-right: 55px;
}

.websiteLabelWidth {
  width: 105px;
  margin-right: 20px;
}

.commentLabelWidth {
  width: 62px;
  margin-right: 62px;
}

.buttonText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
}
</style>
